import React, { useContext } from 'react';
import ReactHtmlParser from 'react-html-parser';
import DefaultContainer from '../DefaultContainer';
import { AppContext } from '../Context';

const IMAGE_MAP = {
  Secure: require('../../imgs/shield.svg'),
  Scalable: require('../../imgs/gears.svg'),
  Documented: require('../../imgs/business.svg'),
  'API & Sandbox': require('../../imgs/sandbox.svg'),
};

const Business = () => {
  const { business } = useContext(AppContext);
  return (
    <DefaultContainer>
      <section className="mb-0 pb-5 px-2" id="business">
          <div className="d-flex flex-column flex-lg-row flex-wrap align-items-center justify-content-center">
            <h3 className="h3 mb-3 text-center text-lg-left theme-color">{ business.header }</h3>
            <div className="text-muted text-center intro-text2">
              { business.desc }
            </div>
          </div>

        <div className="d-lg-none d-flex flex-column justify-content-around align-items-center mt-5">
          <div className="d-flex flex-row flex-column mt-0 x-default-container">
            {
              business.options.map(option => (
                <div className="card px-3 mr-3 card-style mb-2 position-relative business-card" key={option.id}>
                  <div className="d-flex flex-column justify-content-center align-items-center card-body">
                    <div className="business-icon-container">
                      <img src={IMAGE_MAP[option.title]} alt="" height="50" width="50" />
                      <div className="h5 font-weight-bold mt-3 mb-0 business-desc-title">{option.title}</div>
                    </div>
                    <div className="font-14 text-center">{ ReactHtmlParser(option.desc) }</div>
                  </div>
                </div>
              ))
            }
          </div>
        </div>

        <div className="d-none d-lg-flex flex-column justify-content-around align-items-center mt-5">
            <div className="d-flex flex-row mt-0 x-default-container">
              {
                business.options.map(option => (
                  <div className="card px-3 mr-3 card-style mb-2 position-relative business-card" key={option.id}>
                    <div className="d-flex flex-column justify-content-center align-items-center card-body">
                      <div className="business-icon-container">
                        <img src={IMAGE_MAP[option.title]} alt="" height="50" width="50" />
                        <div className="h5 font-weight-bold mt-3 mb-0 business-desc-title">{option.title}</div>
                      </div>
                    </div>
                  </div>
                ))
              }
            </div>
            <div className="d-none d-lg-flex flex-row align-items-lg-start business-text">
              {
                business.options.map(option => (
                  <div className="card px-3 mr-3 card-style mb-2 position-relative business-card" key={option.id}>
                    <div className="d-flex flex-column justify-content-center align-items-center card-body">
                      <div className="business-icon-container">
                        <div className="font-14 text-center">{ ReactHtmlParser(option.desc) }</div>
                      </div>
                    </div>
                  </div>
                ))
              }
            </div>
        </div>
      </section>
    </DefaultContainer>
  );
};

export default Business;
